import { Box, Typography, useMediaQuery } from '@mui/material';
import { useMemo } from 'react';

import { LearningPathHorizontalCard } from '@/components';
import { Routes } from '@/constants';
import { Link } from '@/containers';
import { EVENT_CONSTANTS } from '@/services';
import {
  LearningPathsUtils,
  playerSessionsSelectors,
  selectUserCompliance,
  useAppSelector,
  useFetchLearningPathsQuery,
} from '@/store';

const referrer = {
  page: EVENT_CONSTANTS.PAGE.DISCOVER,
  component: EVENT_CONSTANTS.COMPONENT.LEARNING_PATH_CARD,
};

const ViewAllLink = () => (
  <Link
    to={{
      pathname: Routes.LEARNING_PATHS,
    }}>
    View All
  </Link>
);

export const FeaturedLearningPathsCarousel = () => {
  const compliance = useAppSelector(selectUserCompliance);
  const playerSessions = useAppSelector(playerSessionsSelectors.selectEntities);
  const isLg = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const { data = [] } = useFetchLearningPathsQuery({ compliance });

  const pinnedLps = useMemo(() => {
    const featuredLps = LearningPathsUtils.filterForFeaturedLearningPaths({
      lps: data,
    });

    return LearningPathsUtils.calculateProgress({
      lps: featuredLps,
      playerSessions,
    });
  }, [playerSessions, data]);

  const columnnCount = isLg ? 3 : 1;

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 1,
        }}>
        <Typography variant="h4">Featured Learning Paths</Typography>
        <ViewAllLink />
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {pinnedLps.slice(0, columnnCount).map(lp => (
          <Box key={lp.groupId} sx={{ flex: 1, containerType: 'inline-size' }}>
            <LearningPathHorizontalCard learningPath={lp} referrer={referrer} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
